<template>
  <div id="app">
	<router-view v-if="isRouterAlice"></router-view>
  </div>
</template>
<script type="text/javascript">
	export default {
		 created() {
		 	this.$nextTick(function() {
				let href = window.location.pathname;
				if (href=='/test'||href=='/test/workbench') {
					sessionStorage.removeItem('store')
				}else{
					//在页面加载时读取sessionStorage里的状态信息
					if(sessionStorage.getItem("store")) {
						this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))))
					}
				}
				//在页面刷新时将vuex里的信息保存到sessionStorage里
				window.addEventListener("beforeunload", () => {
					if (window.location.href!='http://localhost:8080/'&&window.location.href!='https://qc.rimagdata.com/test/') {
						sessionStorage.setItem("store", JSON.stringify(this.$store.state))
					}
				})
		 	})
		 },
		 name: 'App',
		   provide() {
		     return {
		       reload: this.reload
		     }
		   },
		   data() {
		     return {
		       isRouterAlice: true
		     }
		   },
		   methods: {
		     reload() {
		       this.isRouterAlice = false
		       this.$nextTick(function() {
		         this.isRouterAlice = true
		       })
		     }
		   }
	}
</script>

